/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cas_Edit_Fund_Visibility_TitleInputs */

const en_cas_edit_fund_visibility_title = /** @type {(inputs: Cas_Edit_Fund_Visibility_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Fund visibility`)
};

/**
* | output |
* | --- |
* | "Edit Fund visibility" |
*
* @param {Cas_Edit_Fund_Visibility_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_edit_fund_visibility_title = /** @type {((inputs?: Cas_Edit_Fund_Visibility_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Edit_Fund_Visibility_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_edit_fund_visibility_title(inputs)
});